import React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import { ExerciseUI } from '@seedlang/state';
import ExerciseSentence from 'components/exercise/exercise_sentence';
import ExerciseWordAssociations from 'components/exercise/exercise_word_associations';
import styled from '@emotion/styled';
import Prompt from 'components/exercise/prompt';
import { StickyClickItemWrapper } from 'components/exercise/sticky_click_item_wrapper';
import SmallGrammarTip from 'components/exercise/small_grammar_tip';

const Wrapper = styled.div`

`;

const ExerciseEntry = styled.div`
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #dadada;
`;

const Sentences = styled.div`
  margin-top: 20px;
`;

@observer
class ExerciseDrag extends React.Component {

  @computed get clickableWordAssociations() {
    return ExerciseUI.exercise.shuffledWordAssociationsWithExtraWords.filter(item => !item.state.assigned);
  }

  render() {
    return (
      <Wrapper>
        {this.clickableWordAssociations.length > 0 &&
          <StickyClickItemWrapper>
            <ExerciseWordAssociations
              clickable
              mobileScrollable
              showAssignedSlots={false}
              wordAssociations={ExerciseUI.exercise.shuffledWordAssociationsWithExtraWords}
              onSetValueToWordAssociation={ExerciseUI.onSetValueToWordAssociation}
              setAssignedWordAssociations={ExerciseUI.setAssignedWordAssociations}
              onClick={ExerciseUI.assignToNextWordAssociation}
              inDeck={this.props.inDeck}
            />
          </StickyClickItemWrapper>
        }

        <Sentences>
          {
            ExerciseUI.exercise.exerciseEntries.map(item => {
              return (
                <ExerciseEntry
                  key={item.id}
                  {...this.props}
                >
                  {
                    item.prompt &&
                      <Prompt>
                        {item.prompt}
                      </Prompt>
                  }
                  {
                    item.sentence &&
                      <ExerciseSentence
                        inputType='reorder'
                        sentence={item.sentence}
                        revealed={ExerciseUI.exercise.state.revealed}
                        exercise={ExerciseUI.exercise}
                        hideLanguageButton={!item.showSource}
                      />
                  }
                  {
                    item.grammarTip && !this.props.inDeck &&
                      <SmallGrammarTip
                        grammarTip={item.grammarTip}
                        showTipIcon={ExerciseUI.exercise.showTipIcon}
                      />
                  }
                </ExerciseEntry>
              );
            })
          }
        </Sentences>
      </Wrapper>
    );
  }
}

export default ExerciseDrag;
